import LivePageTimer from './LivePageTimer'

export default LivePageTimer
// eslint-disable-next-line import/export
export * from './LivePageTimer'
